import { Box, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import styled from 'styled-components';

export const GridCell = styled(Box)<{ align?: 'left' | 'right' }>`
  padding: 15px;
  border-bottom: 1px solid ${themedColor('glass')};
  text-align: ${props => props.align || 'left'};

  ${MEDIA_QUERIES.tabletAndDesktop`
    text-align: center;
  `}
`;
